// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"936":"292c89ad531833a0","1221":"54d8eea5f3650198","3602":"ed5151da634213c0","4937":"b838bc93f7a89c76","7547":"f964fb330426eb58","8486":"de47368183b5bbb2"}[chunkId] + ".css";
};